import { useState, useEffect, useCallback } from 'react';
import APIRequest from '~/lib/api_request';

const useStats = ({ resources, resource, initialState = {} }) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(initialState);
  const [error, setError] = useState(null);

  const resourceKey = JSON.stringify({ resources, resource });

  const loadData = useCallback(async () => {
    setLoading(true);
    try {
      if (resources) {
        const responses = await Promise.all(
          resources.map((r) => APIRequest.get({ resource: r })),
        );

        const hasError = responses.some((r) => !r?.ok);
        if (hasError) {
          setError(new Error('Failed to load some data'));
          return;
        }

        const combinedData = responses.reduce((acc, r, index) => ({
          ...acc,
          [resources[index].split('/').pop()]: r.body,
        }), {});

        setData(combinedData);
      } else if (resource) {
        const response = await APIRequest.get({ resource });
        if (response?.ok) {
          setData(response.body);
        } else {
          setError(new Error('Failed to load data'));
        }
      }
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [resourceKey]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  return {
    data, loading, error, refresh: loadData,
  };
};

export default useStats;
